import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { EncapsuleMove } from './EncapsuleMove';
import { EncapsulePiece } from './EncapsulePiece';
import { EncapsuleRules } from './EncapsuleRules';
export class EncapsuleMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const moves = [];
        const state = node.gameState;
        const currentPlayer = state.getCurrentPlayer();
        const puttablePieces = state.getRemainingPiecesOfPlayer(currentPlayer).getKeyList();
        const width = state.getWidth();
        const height = state.getHeight();
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            // each drop
            for (const pieceSize of puttablePieces) {
                const piece = EncapsulePiece.ofSizeAndPlayer(pieceSize, currentPlayer);
                const move = EncapsuleMove.ofDrop(piece, coord);
                const status = EncapsuleRules.get().isLegal(move, state);
                if (status.isSuccess()) {
                    moves.push(move);
                }
            }
            if (coordAndContent.content.belongsTo(currentPlayer)) {
                for (let ly = 0; ly < height; ly++) {
                    for (let lx = 0; lx < width; lx++) {
                        const landingCoord = new Coord(lx, ly);
                        if (landingCoord.equals(coord) === false) {
                            const newMove = EncapsuleMove.ofMove(coord, landingCoord);
                            const status = EncapsuleRules.get().isLegal(newMove, state);
                            if (status.isSuccess()) {
                                moves.push(newMove);
                            }
                        }
                    }
                }
            }
        }
        return moves;
    }
}
